export enum RoutingIdentifier {
  START = '/',
  LOGIN_CALLBACK = '/login-callback',
  UNAUTHORIZED = '/unauthorized',
  CONTENT_OVERVIEW = '/content-overview',
}
